import { Component, OnDestroy, OnInit, Input, ElementRef, Output, EventEmitter, OnChanges } from '@angular/core';
import { MysqlService } from './../../../services/mysql.service';
import { FileUploaderService } from './../../../services/file-uploader-service';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal'
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';


@Component({
  selector: 'app-user-password-expired-modal',
  templateUrl: './user-password-expired-modal.component.html',
  styleUrls: ['./user-password-expired-modal.component.css']
})
export class UserPasswordExpiredModalComponent implements OnInit {

  // @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();

  @Input() title = 'Password Expired Reset';
// as a model vars
  @Input() item_id: number;
  @Input()  closeBtnName: string;
  @Input() list: any[] = [];
  @Input() user_id: number;


loading: boolean;
// set an event emitter to send back to parent component
@Output() action = new EventEmitter();

sessionBrandId: any;
sessionUsername: any;
sessionUserId: any;
currentUserVAR: any;

div: any;
public nav: any;
public body: any;
public container: any;
// Uploader Service Vars
// public title = 'File Upload Manager - Brands';
// public imgUploaded: string;
public tableData: any;
public baseUploadURL = this.gfunc.baseUploadURL_UserAssets; // no trailing slash // added brand_id to HTML 
  all_router_details: string;
  current_base_route: string;


  constructor(   private _mysqlService: MysqlService, private route: ActivatedRoute, private router: Router,
    private fileUploader: FileUploaderService, private elem: ElementRef, public bsModalRef: BsModalRef,
    private modelService: BsModalService, public gfunc: GlobalFunctionsService ) { 

      // Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
this.current_base_route = this.router.url.substr(0, this.router.url.lastIndexOf('/'));
    }

  ngOnInit() {
  }

// Uploader Functions
public uploadUserImage(user_id): void {
  this.elem.nativeElement.querySelector('#spinner').style.visibility='visible';
let files = this.elem.nativeElement.querySelector('#selectFile').files;
let formData = new FormData();
let file = files[0];
formData.append('selectFile', file, file.name);
this.fileUploader.uploadUserImage(formData, user_id).subscribe(res=> this.dataLoaded(res));

}


dataLoaded(data: any): void {
this.elem.nativeElement.querySelector('#spinner').style.visibility='hidden';
 // this.imgUploaded = data._body;
this.refreshList();
}

refreshList(): void {
this.fileUploader.getUsersList(this.user_id).subscribe(res=> this.displayTableData(res));

}

displayTableData(data: any): void {
this.tableData = data.json();
}

// end uploader functions


loadList(user_id): void {
  this.fileUploader.getUsersList(user_id).subscribe(res=> this.displayTableData(res));
  
  }



public clickOk() {
  // tslint:disable-next-line:indent
  this.loading = true;
  this.action.emit(true); /// << here you can send object  instead of true
}


public clickFile(filename) {
  // tslint:disable-next-line:indent
  this.loading = true;
  this.action.emit(filename); /// << here you can send object  instead of true
  this.bsModalRef.hide();
}


  //::  changed for component

  // :: Parent / Child modal test
  closeParentModel() {
    // alert('parent component function.');
    this.bsModalRef.hide();
   // this.refreshGrid(); // resets the grid if updated and closed.
  //  this.updateTypeClick = false; // closes the div
  };
  


}
